module.exports = __webpack_public_path__ + "static/media/r_itdot_7.c04861c2.png";